import qs from 'qs';
import cleanDeep from 'clean-deep';

const questionAdvicesEndpoint = (entity = 'reviews', id) => {
  // If id is not provided, return a config that won't make API calls
  if (!id) {
    return {
      dataURL: `professions/${entity}`,
      sourceName: entity,
      autoLoad: false,
      getDataUrl: (url, { page, perPage }) => {
        // Return null to prevent API calls when professionId is missing
        // The dataList service should handle this gracefully
        return null;
      },
      mapData: (payload, state, concat) => {
        // Return empty data structure when no professionId
        return {
          data: [],
          page: 1,
          perPage: 2,
          count: 0
        };
      }
    };
  }

  return {
    dataURL: `professions/${entity}/${id}`,
    sourceName: entity,
    autoLoad: true,
    getDataUrl: (url, { page, perPage }) => {
      // Early return if url is null (shouldn't happen with valid id, but safety check)
      if (!url) {
        return null;
      }

      const urlData = {};

      const offset = ((page || 1) - 1) * perPage;

      urlData.offset = offset;

      urlData.limit = perPage;

      const queryString = qs.stringify(cleanDeep(urlData, { NaNValues: true }));

      return url + (queryString && '?' + queryString);
    },
    mapData: (payload, state, concat) => {
      const { meta } = payload;
      const { limit, count, offset } = meta || {};

      return {
        data: concat ? (state.data || []).concat(payload) : payload,
        page: Math.ceil(Number(offset) / Number(limit)) + 1,
        perPage: limit,
        count
      };
    }
  };
};

export default questionAdvicesEndpoint;
